import React, { FC, useEffect, useState } from 'react';
import { Button } from '../components/Button';
import { DirectoryBar } from '../components/DirectoryBar';
import { H3 } from '../components/H3';
import { H5 } from '../components/H5';
import { useHistory, useParams } from 'react-router-dom';
import queryString from 'query-string';
import {
  getNotUserOrderDetail,
  getOrderHistoryDetail, orderChangeAvailable,
  orderRequestConfirm,
} from '../apis/orders';
import {OrderResult, TOrderDetail} from '../types/types';
import moment from 'moment';
import { stringToDate, swapPayMethod } from '../utils/texts';
import {useUserDispatch, useUserState} from '../context/UserContext';
import {Bridge} from "../plugins/bridge";
import {BRAZE_EVENT} from "../constants/braze";
import {getUserInfo} from "../apis/user";
import { ButtonEventProperties } from '../types/amplitudeEventProperties';
import { AIRBRIDGE_EVENT } from '../constants/airbridge';
import { isMobile } from 'react-device-detect';
import {iamportPaymentConfirm, iamportPaymentMobileConfirm} from "../apis/iamport";
import {H4} from "../components/H4";
import {nToast} from "../plugins/reactToast";
import {RequestPopup} from "../components/RequestPopup";

function onClicKeepShopping(page : string){
  const buttonEventProperties : ButtonEventProperties = {
      button_page : page
  }

  Bridge.sendAmplitude('keep_shopping_button_clicked', buttonEventProperties);
  Bridge.sendBraze(BRAZE_EVENT.KEEP_SHOPPING_BUTTON_CLICKED, buttonEventProperties);

}

const CartRequestSuccessPage = () => {
  const { mobile } = useParams<{ mobile: string }>();
  const history = useHistory();
  const paymentData = queryString.parse(history.location.search);
  const [orderResult, setOrderResult] = useState<OrderResult>();
  const { isLoggedIn } = useUserState();
  const userDispatch = useUserDispatch();
  const [orderDetail, setOrderDetail] = useState<TOrderDetail>();
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    getUserInfo().then(r => userDispatch({
      type: 'LOGIN',
      payload: r.data.payload
    })).catch(e => userDispatch({type: 'LOGOUT'}));
  }, [])

  useEffect(() => {
    if (paymentData.imp_success === 'false' || paymentData.resultMessage !== '') {
      (!!paymentData.resultMessage || !!paymentData.error_msg) && alert(paymentData.resultMessage || paymentData.error_msg);
    }
    if (isLoggedIn !== undefined) {
      if (mobile === 'mobile' && paymentData.imp_uid) {
        iamportPaymentMobileConfirm('carhartt', {
            imp_uid: paymentData.imp_uid as string,
            merchant_uid: paymentData.merchant_uid as string,
            imp_success: paymentData.imp_success === 'true',
        }).then(r => {
            getMobileDetailInfo(r.data.payload.orderNumber);
            const getDetail = isLoggedIn ? getMemberDetail : getNonMemberDetail;
            getDetail(r.data.payload.orderNumber).then(r => {
                setOrderDetail(r.data.payload);
              });
        });

      } else if (paymentData.imp_uid) {
        iamportPaymentConfirm({imp_uid: paymentData.imp_uid as string, merchant_uid: paymentData.merchant_uid as string}).then(r => {
              setOrderResult(r.data.payload);
              const getDetail = isLoggedIn ? getMemberDetail : getNonMemberDetail;
              getDetail(r.data.payload.orderNumber).then(r => {
                setOrderDetail(r.data.payload);
                sendDataToBraze(r.data.payload);
              });
            },
        ).catch(e => console.log(e));
      }
    }
  }, [isLoggedIn, history.location]);

  const getMobileDetailInfo = (orderNumber: string) => {
    const getDetail = isLoggedIn ? getMemberDetail : getNonMemberDetail;
    // @ts-ignore
    getDetail(orderNumber).then(r => {
      const data = r.data.payload;
      setOrderResult({
        expiredAt: data.orderRequestExtra?.virtualAccountValid,
        orderNumber: data.orderRequestExtra?.requestOrderNumber!,
        orderedAt: data.orderRequestExtra?.requestedAt!,
        payMethod: data.orderRequestExtra?.payMethod!,
        productNames: `${
            data.orderRequestExtra?.products[0].productName
        }외 ${data.orderRequestExtra?.products.length! - 1}개`,
        totalPrice: data.orderRequestExtra?.requestPrepaidPrice!,
        virtualAccountBank: data.orderRequestExtra?.virtualAccountBank,
        virtualAccountNumber: data.orderRequestExtra?.virtualAccountNumber,
        virtualAccountOwner: data.orderRequestExtra?.virtualAccountOwner,
      });
      sendDataToBraze(data);
    }).catch(e => console.log(e));
  }

  const getNonMemberDetail = (orderNumber: string) => {
    console.log('not user');
    const customerName = localStorage.getItem('customerName');
    const customerPhone = localStorage.getItem('customerPhone');
    return getNotUserOrderDetail(orderNumber, {
      customerName: customerName!,
      customerPhone: customerPhone!,
    });
  };

  const getMemberDetail = (orderNumber: string) => {
    return getOrderHistoryDetail(orderNumber);
  };

  const sendDataToBraze = (order: TOrderDetail) => {
    switch (order.orderRequestExtra?.type) {
      case 'RETURN':
        Bridge.sendBraze(BRAZE_EVENT.RETURN_APPLYED, {
          non_member_order: !isLoggedIn,
          item_id: order.orderRequestExtra?.products.map(p => p.productId).join(','),
          item_name: order.orderRequestExtra?.products.map(p => p.productName).join(','),
          item_category: undefined,
          item_color: order.orderRequestExtra?.products.map(p => p.color).join(','),
          item_gender: undefined,
          item_size: order.orderRequestExtra?.products.map(p => p.sizeName).join(','),
          item_price: order.orderRequestExtra?.products.map(p => p.unitPrice).join(','),
          order_item_quantity: order.orderRequestExtra?.products.map(p => p.count).join(','),
          total_order_items_quantity: order?.orderRequestExtra?.products.map(product => product.count).reduce((a, b) => a + b, 0),
          sub_total: order.orderRequestExtra?.products.map(p => p.unitPrice * p.count).reduce((a, b) => a + b, 0),
          payment_method: swapPayMethod(order.orderRequestExtra?.payMethod!),
          paid_shipping: order?.orderRequestExtra?.requestDeliveryPrice,
          paid_point: undefined,
          coupon_id: undefined,
          coupon_name: undefined,
          reward_point: undefined,
          order_id: order?.orderRequestExtra?.requestOrderNumber,
          order_total: order?.orderRequestExtra?.totalPaidPrice,
          return_reason: order.orderRequestExtra?.products.map(p => p.latestRequestReason).join(','),
        });


        break;
      case 'EXCHANGE':
        Bridge.sendBraze(BRAZE_EVENT.EXCHANGE_APPLYED, {
          non_member_order: !isLoggedIn,
          item_id: order.orderRequestExtra?.products.map(p => p.productId).join(','),
          item_name: order.orderRequestExtra?.products.map(p => p.productName).join(','),
          item_brand: order.orderRequestExtra?.products.map(p => p.brandName).join(','),
          item_category: undefined,
          item_color: order.orderRequestExtra?.products.map(p => p.color).join(','),
          item_gender: undefined,
          item_size: order.orderRequestExtra?.products.map(p => p.sizeName).join(','),
          item_price: order.orderRequestExtra?.products.map(p => p.unitPrice).join(','),
          order_item_quantity: order.orderRequestExtra?.products.map(p => p.count).join(','),
          total_order_items_quantity: order?.orderRequestExtra?.products.map(product => product.count).reduce((a, b) => a + b, 0),
          sub_total: order.orderRequestExtra?.products.map(p => p.unitPrice * p.count).reduce((a, b) => a + b, 0),
          payment_method: swapPayMethod(order.orderRequestExtra?.payMethod!),
          paid_shipping: order?.orderRequestExtra?.requestDeliveryPrice,
          order_id: order?.orderRequestExtra?.requestOrderNumber,
          order_total: order?.orderRequestExtra?.totalPaidPrice,
          exchange_reason: order.orderRequestExtra?.products.map(p => p.latestRequestReason).join(','),
        });
        Bridge.sendAirbridge(AIRBRIDGE_EVENT.orderComplete, {
          value: order?.totalPrice,
          action: "교환신청",
          semanticAttributes: {
            transactionID: order?.orderId,
            inAppPurchased: isMobile,
            totalValue: order?.totalPrice,
            currency: "KRW",
            totalQuantity: order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
            products: order?.products
          }
        });
        break;
    }
  }

  const checkAvailableChangeAddress = () => {
    orderChangeAvailable(orderResult?.orderNumber!)
        .then(() => history.push(isLoggedIn ? `/mypage/refunds/${orderResult?.orderNumber}` : `/non-member/refunds/${orderResult?.orderNumber}`))
        .catch(() => nToast('택배 회수 접수가 완료되어 회수지 변경이 불가능합니다.'));
  }

  if (!orderResult) return null;
  return (
    <>
      <RequestPopup open={popupOpen} onClose={() => setPopupOpen(false)}
                    onOK={() => {
                      setPopupOpen(false);
                      history.push(`/mypage/refunds/${orderResult?.orderNumber}`);
                    }}
      />
      <DirectoryBar text="홈, 장바구니" />

      <div className="flex flex-col items-center justify-center mt-6 md:mt-16 pb-40 px-4">
        <H3 className="font-semibold">교환/반품 신청이 완료되었습니다.</H3>
        <p className="text-13 text-left pt-4 pb-6 text-gray-500 max-w-md">
          • 영업일 기준 2~3일 이내에 기사님께서 방문하실 예정입니다.<br/>
          • 제품이 분실되지 않도록 기사님께 안전하게 인계 부탁드립니다.<br/>
          • 교환 제품은 입고 → 검수 후 교환 처리 시점 품절일 경우 환불로만 처리됩니다.<br/>
          • 교환/반품 접수없이 일방적으로 보낸 상품 또는 교환 및 환불로 처리가 불가한 경우 착불로 반송 처리됩니다.<br/>
          • 교환/반품 신청 진행 상태에 따라 신청 취소가 불가할 수 있습니다.<br/>
          • 교환/반품 취소가 불가할 경우 웹/앱 우측하단 채널톡으로 문의해주세요.<br/>
          • 회수지/수령지 변경할 경우 상품 수거 및 수령 주소가 모두 변경됩니다.<br/>
          • 회수지/수령지 변경 가능 시간 : 오후 5시 이전 교환/반품 신청 완료 시 → 당일 오후 5시 이전 주소지 변경 가능<br/>
        </p>
        <H5 className="font-semibold">회수지/수령지 변경을 원하실 경우 하단 배송정보 변경 버튼을 선택해주세요.</H5>

        <div className="max-w-lg mx-auto w-full space-y-4 my-5">
          <InfoItem title="현재 회수지 정보"
                    description={''}
          />
          <InfoItem title="이름"
                    description={orderDetail?.receiverName!}
          />
          <InfoItem title="전화번호"
                    description={orderDetail?.receiverPhone!}
          />
          <InfoItem title="주소"
                    description={`${orderDetail?.receiverAddress} ${orderDetail?.receiverDetailAddress}`}
          />
          <InfoItem title="요청사항"
                    description={orderDetail?.shippingRequest || '-'}
          />
        </div>


        <div className="max-w-lg mx-auto w-full">
          {/*<div className="flex justify-between border-b pb-6 mb-6">*/}
          {/*  <H5>총 결제 금액</H5>*/}
          {/*  <H3 className="font-semibold">*/}
          {/*    ₩{orderResult.totalPrice.toLocaleString()}*/}
          {/*  </H3>*/}
          {/*</div>*/}

          {/*<div className="space-y-4">*/}
          {/*  <InfoItem*/}
          {/*    title="주문일시"*/}
          {/*    description={moment(orderResult.orderedAt).format(*/}
          {/*      `YYYY.MM.DD hh:mm:ss`,*/}
          {/*    )}*/}
          {/*  />*/}
          {/*  {orderResult.payMethod === 'VIRTUAL_ACCOUNT' && (*/}
          {/*    <InfoItem*/}
          {/*      title="결제기한"*/}
          {/*      description={*/}
          {/*        mobile*/}
          {/*          ? stringToDate(orderResult.expiredAt!)*/}
          {/*          : moment(orderResult.expiredAt).format(*/}
          {/*              `YYYY.MM.DD hh:mm:ss`,*/}
          {/*            )*/}
          {/*      }*/}
          {/*    />*/}
          {/*  )}*/}
          {/*  <InfoItem*/}
          {/*    title="주문서 번호"*/}
          {/*    description={orderResult.orderNumber}*/}
          {/*  />*/}
          {/*  <InfoItem title="상품" description={orderResult.productNames} />*/}
          {/*  <InfoItem*/}
          {/*    title="결제수단"*/}
          {/*    description={swapPayMethod(orderResult.payMethod)}*/}
          {/*  />*/}
          {/*  {orderResult.payMethod === 'VIRTUAL_ACCOUNT' && (*/}
          {/*    <>*/}
          {/*      <InfoItem*/}
          {/*        title="계좌번호"*/}
          {/*        description={`${orderResult.virtualAccountBank} ${orderResult.virtualAccountNumber}`}*/}
          {/*      />*/}
          {/*      <InfoItem*/}
          {/*        title="예금주명"*/}
          {/*        description={orderResult.virtualAccountOwner!}*/}
          {/*      />*/}
          {/*    </>*/}
          {/*  )}*/}
          {/*</div>*/}

          <div className={'grid md:block text-center my-5'}>
            <Button onClick={checkAvailableChangeAddress}
                    text="배송정보 변경"
                    className="filled-brand-1 md:w-60"
            />
          </div>

          <div className={`grid ${isLoggedIn && 'md:grid-cols-2'} gap-4 mt-16`}>
            {isLoggedIn && (
              <Button
                to="/mypage/orders"
                text="주문 / 배송 조회"
                className="filled-brand-1"
              />
            )}
            <Button to="/" text="홈으로" className="outlined-gray-900"
              onClick={()=>{onClicKeepShopping('장바구니 주문 성공')}}/>
          </div>
        </div>
      </div>
    </>
  );
};

interface InfoItemProps {
  title: string;
  description: string;
}

export const InfoItem: FC<InfoItemProps> = ({ title, description }) => {
  return (
    <div className="text-14 flex justify-between">
      <p className="text-gray-500 min-w-20">{title}</p>
      <p className="">{description}</p>
    </div>
  );
};

export default CartRequestSuccessPage;
